import { usePageData } from '@/common/composables/usePageData'
import {
  hasActionRoleAccess as checkActionRoleAccess,
  mergeUserRoleIds,
} from '@/common/utils/actionRoleAccess'
import {
  collectRoleIdsForRestrictions,
  normalizeUserFieldsMap,
} from '@/services/server-events/chainUserFields'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'

export function useActionRoleAccess() {
  const userStore = useUserStore()
  const appStore = useAppStore()
  const { pageFields } = usePageData()

  const effectiveUserRoleIds = computed(() => {
    const chainRoot = appStore.sessionChainData
    const chainFields = normalizeUserFieldsMap(
      chainRoot?.fields?.fields ?? chainRoot?.fields ?? null,
    )
    return mergeUserRoleIds(
      userStore.roleIds,
      collectRoleIdsForRestrictions(chainFields),
      collectRoleIdsForRestrictions(pageFields.value as Record<string, unknown>),
    )
  })

  const hasActionRoleAccess = (actionRoles: unknown): boolean =>
    checkActionRoleAccess(actionRoles, effectiveUserRoleIds.value)

  return {
    effectiveUserRoleIds,
    hasActionRoleAccess,
  }
}
